import React from 'react';

import { Skeleton } from '@mui/material';
import { t } from 'i18next';

import { ICompanyPlan } from '../../../../../shared/interfaces/plans';
import { TRANSLATION_MANAGE_COLLABORATORS } from '../../../../../shared/translations/manageCollaborators';
import Addons from '../PlanAddons/PlanAddons';
import './SubscriptionCollaboratorsHeadingContainer.scss';

interface ISubscriptionCollaboratorsHeadingContainer {
  loading: boolean;
  emailsCounter: number;
  planSelected: ICompanyPlan;
}

const SubscriptionCollaboratorsHeadingContainer = ({
  emailsCounter,
  loading,
  planSelected
}: ISubscriptionCollaboratorsHeadingContainer) => {
  const renderSkeletons = () => {
    return (
      <div className="skeletons flex flex-row justify-between w-full">
        <Skeleton className="skeleton" animation={false} />
        <Skeleton className="skeleton" animation={false} />
      </div>
    );
  };

  return (
    <div className="top-information flex flex-col w-full">
      <div className="flex flex-row align-center justify-between">
        {loading ? (
          renderSkeletons()
        ) : (
          <>
            <span>{t(TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.uploadByEmails.planLabel)}</span>
            <span>
              {t(TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.uploadByEmails.addDescription, {
                count: emailsCounter
              })}
            </span>
          </>
        )}
      </div>
      <div className="flex flex-row align-center justify-between">
        {loading ? (
          renderSkeletons()
        ) : (
          <>
            <div className="plan">
              <h3 className="name">{planSelected.name}</h3>
              <Addons planAddons={planSelected.addons} />
            </div>
            <h3>
              {t(TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.uploadByEmails.collaboratorsCounter, {
                users: emailsCounter,
                count: emailsCounter
              })}
            </h3>
          </>
        )}
      </div>
    </div>
  );
};

export default SubscriptionCollaboratorsHeadingContainer;
